import { useCallback, useState } from "react";
import { getReviews } from "../../../api";
import { GetReviewsResponse } from "../../../types/requestsOutputs";

interface FetchArgs {
    trackIds: string[];
    startDate: Date;
    endDate: Date;
}

interface UseReviews {
    data: GetReviewsResponse | null;
    loading: boolean;
    error: string | null;
    fetch: (args: FetchArgs) => Promise<void>;
    reset: () => void;
}

export const useReviews = (): UseReviews => {
    const [data, setData] = useState<GetReviewsResponse | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetch = useCallback(async ({ trackIds, startDate, endDate }: FetchArgs) => {
        const token = localStorage.getItem("token");
        if (!token) {
            setError("missing-token");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await getReviews({ token, trackIds, startDate, endDate });
            setData(res);
        } catch (e: any) {
            setError(e?.message || "unknown-error");
        } finally {
            setLoading(false);
        }
    }, []);

    const reset = useCallback(() => {
        setData(null);
        setError(null);
    }, []);

    return { data, loading, error, fetch, reset };
};
